import { API_URL, API_LOGIN, API_PASS } from '../../config/config';
import { loadCode } from '../../storage';


export async function getSearch(oQ) {
	let app_key = loadCode()
	const url = API_URL + '?' + new URLSearchParams({
		app_key: app_key,
		...oQ
	})
	try {
		const response = await fetch(url, {
			// headers: new Headers({
			// 	"Authorization": `Basic ${btoa(`${API_LOGIN}:${API_PASS}`)}`
			// }),
		})


		const o = await response.json();
		return o

	} catch (error) {
		console.log(`url`, url)
		console.log('error fetching data:', error)
		console.error(error)
	}

}

/*
[
	{"publicId":"jiaufa-po2b8k4jkh", "nsfw":1},
	{"publicId":"4ibdlp-po2dmc5hk8", "nsfw":1}
]
*/
export async function postUpdates(payloads) {
	let app_key = loadCode()
	const url = API_URL + '?' + new URLSearchParams({
		app_key: app_key
	})
	try {
		const response = await fetch(url, {
			method:'PUT',
			body:JSON.stringify(payloads)
			// headers: new Headers({
			// 	"Authorization": `Basic ${btoa(`${API_LOGIN}:${API_PASS}`)}`
			// }),
		})
		const o = await response.json();
		return o

	} catch (error) {
		console.log(`url`, url)
		console.log('error fetching data:', error)
		console.error(error)
	}
}


export async function postLikes(payloads) {
	let app_key = loadCode()
	const url = API_URL + '?' + new URLSearchParams({
		app_key: app_key
	})
	try {
		const response = await fetch(url, {
			method:'POST',
			body:JSON.stringify(payloads)
			// headers: new Headers({
			// 	"Authorization": `Basic ${btoa(`${API_LOGIN}:${API_PASS}`)}`
			// }),
		})

		const o = await response.json();
		return o

	} catch (error) {
		console.log(`url`, url)
		console.log('error fetching data:', error)
		console.error(error)
	}
}


export function getLikes(){
	let data = localStorage.getItem('galeria_likes');
    if (!data) return [];
    try {
        data = JSON.parse(data);
    } catch (error) {
        data = []
    }
    return data;
}
function saveLikes(likes){
	localStorage.setItem('galeria_likes', JSON.stringify(likes));
}

//arry of like ids in
export function localLike(_publicIds){
	let publicIds=[]
	if(!Array.isArray(_publicIds)){
		publicIds = [_publicIds]
	}else{
		publicIds = [..._publicIds]
	}
	const aLikes = getLikes()
	for(const publicId of publicIds){
		if(aLikes.indexOf(publicId)<0) aLikes.push(publicId)
	}
	saveLikes(aLikes)
	return aLikes;
}

//arry of like ids in
export function localUnlike(_publicIds){
	let publicIds=[]
	if(!Array.isArray(_publicIds)){
		publicIds = [_publicIds]
	}else{
		publicIds = [..._publicIds]
	}
	const aLikes = getLikes().filter(pid=>publicIds.indexOf(pid)<0)
	saveLikes(aLikes)
	return aLikes;
}